import { Index } from 'algoliasearch/lite';
import algoliasearch from 'algoliasearch/lite'

const algolia = algoliasearch('8SXLOUKLVL', 'df9e43dc9551041dfb26d71f3afab382');

export const algoliaProducts: Index = algolia.initIndex('products')
